import useAxios from 'hooks/useAxios';

export async function resetBlackjackV2Table(tableId, removePlayers = true) {
  const api = useAxios();

  try {
    const res = await api.post('/blackjack/reset-table', {
      tableId,
      removePlayers
    });
    return res;
  } catch (err) {
    return err;
  }
}
